<template lang="pug">
el-upload.newthumbnail-uploader(
  ref="upload"
  :accept='acceptExts[format]'
  list-type="picture-card"
  :file-list="fileList"
  :show-file-list="true"
  :auto-upload="true"
  :data='access'
  :action='action'
  :multiple="multiple"
  :limit="limit"
  :before-upload='beforeUpload'
  :on-remove="onRemoveHandler"
  :before-remove="onBeforeRemoveHandler"
  :on-progress='onProgress'
  :on-success='onSuccessHandler'
  :on-error='onError'
  :class="{'hide-uploader': hideUploader}"
  :on-exceed="onExceed"
)
  .el-upload__tip(slot='tip') {{tip}}
  //- img.thumbnail(v-if='files', :src='files')
  i.el-icon-plus.newthumbnail-uploader-icon

</template>

<script>
import Vue from 'vue';
import Newuploader from 'lib/mixins/Newuploader';

export default {
  name: 'oss-newthumbnail',
  mixins: [Newuploader],
  props: {
    format: {
      type: String,
      default: 'image'
    },
    tip: {
      type: String
    },
    count: {
      type: Number,
      default: 1
    },
    minHeight:{
      type: Number,
      default: 0
    },
    minWidth:{
      type: Number,
      default: 0
    },
    //  等分作业上传图片使用
    index:{
      type: Number,
      default: 0
    },
    files:{
      type: [Array,String],
      default: []
    },
  },
  data() {
    return {
      limit: 1,
      isNeedSave: 1, // 1 保存为封面、头像等不在课件中展示
      acceptExts: {
        image: '.jpg,.jpeg,.png',
        file: '.jpg,.jpeg,.png,.gif,.zip,.pdf'
      },
      acceptTypes: ['image/png', 'image/jpeg'],
      hideUploader: false,
      multiple: false,
      docId: '',
      docUrl: '',
      waitDeleteurl:''
    };
  },
  watch: {
    //
  },
  created() {
    if (this.count != 1) {
      this.limit = this.count;
      this.multiple = true;
    } else {
      this.limit = 2;
    }
  },
  beforeDestroy() {
    this.fileList = [];
  },
  methods: {
    beforeUpload(file) {
      var that = this;
      if (this.format === 'image') {
        let isPngJpg = this.acceptTypes.includes(file.type);
        if (!isPngJpg) {
          this.$message.info({
            title: file.name,
            message: '只能上传 PNG / JPG 格式的图片'
          });
          return false;
        }
      }

      var fileData = file;
      //读取图片数据
      return new Promise(resolve => {
        var reader = new FileReader();
        reader.onload = function (e) {
            var data = e.target.result;
            //加载图片获取图片真实宽度和高度
            var image = new Image();
            image.src= data;
            image.onload=function(){
                var width = image.width;
                var height = image.height;
                if(image.width > that.minWidth && image.height > that.minHeight){
                  if (that.count === 1) {
                    let f = that.$refs.upload.uploadFiles;
                    if (f.length > 1) {
                      let uf = f[0];
                      console.log(uf);
                      that.$refs.upload.handleRemove(uf);
                      // this.fileList.shift();
                    }
                  }
                  that.addFile(file).then(resolve);
                  // reader.readAsDataURL(fileData);
                  // return;
                }else{
                  that.$message.warning("上传图片必须大于:"+ that.minWidth+"*"+that.minHeight);
                  that.files = [];
                  return false;
                }
            };
            // image.src= data;
        };
        reader.readAsDataURL(fileData);
      });
      // if (this.count === 1) {
      //   let f = this.$refs.upload.uploadFiles;
      //   if (f.length > 1) {
      //     let uf = f[0];
      //     console.log(uf);
      //     this.$refs.upload.handleRemove(uf);
      //     // this.fileList.shift();
      //   }
      // }
      // // let isLt1M = file.size / 1024 / 1024 < 1;
      // // if (!isLt1M) {
      // //   this.$notify.info({
      // //     title: file.name,
      // //     message: "单张图片不得大于 1 MB 的限制"
      // //   });
      // //   return false;
      // // }
      // return this.addFile(file);
    },
    onExceed(files, fileList) {
      this.$message.warning(
        `本次选择了 ${files.length} 个文件，共选择了 ${files.length +fileList.length} 个文件, 超出单次最大上传文件 ${this.limit} 个的限制`
      );
    },
    onRemoveHandler(val) {
      if (this.onRemove) {
        this.onRemove();
      }
      // 登分作业批阅删除图片
      this.$emit('deleteFile', {index: this.index,docUrl: this.waitDeleteurl});
    },
    onBeforeRemoveHandler(file, fileList){
      this.waitDeleteurl = file.url;
    },
    onSuccessHandler(res, file, uploadFiles) {
      // 执行mixins里的onSuccess, 继续下一个文件
      if (this.onSuccess) {
        this.onSuccess(res, file, uploadFiles);
      }
      if (res.code > 0) {
        file.url = res.docPath;
        this.$emit('update:docId', res.docId);
        // 登分作业批阅保存图片
        this.$emit('saveFile', {index: this.index,docId: res.docId});
      }
    }
  }
};
</script>
<style lang="scss">
.thumbnail-uploader{
    .el-upload-list--picture-card{
        .el-upload-list__item{
            width:200px;
            height: 120px;
        }
    }
    .thumbnail-uploader-icon{
        margin-top:0;
        font-size:40px;
    }
    .el-upload--picture-card{
        width:200px;
        height: 120px;
    }
}
</style>
